import { DraftsStorage } from '../../../context'
import { useConstant, useUserData } from '../../../hooks'
import { DraftsLocalStorage } from '../DraftsLocalStorage'

function DraftStorageProvider({ children }) {
  const { directory_id: userId } = useUserData()

  const storage = useConstant(() => new DraftsLocalStorage())

  const value = {
    getItem: draftId => storage.getItem(userId, draftId, null),
    setItem: (draftId, draft) => storage.setItem(userId, draftId, draft),
  }

  return <DraftsStorage value={value}>{children}</DraftsStorage>
}

export default DraftStorageProvider
